import { render, staticRenderFns } from "./BadBrowser.vue?vue&type=template&id=5ee86f4a&scoped=true"
import script from "./BadBrowser.vue?vue&type=script&lang=js"
export * from "./BadBrowser.vue?vue&type=script&lang=js"
import style0 from "./BadBrowser.vue?vue&type=style&index=0&id=5ee86f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee86f4a",
  null
  
)

export default component.exports